/**
 * We take the approach of organizing each “cast member” in a scene within its own file.
 * This is a choice and isn’t required, but it does isolate internal changes/enhancements
 * to these specific “characters.”
 */
import {Group, DoubleSide, CylinderGeometry, BoxGeometry, BufferGeometry, LineBasicMaterial, Line,  Vector3, MeshBasicMaterial, Mesh} from 'three'
/**
 * The use of a JavaScript “class” is also a design choice.
 */

class Straws {
    constructor() {
      this.group = new Group()
      this.lines = new Group()
      this.group.materials = []

      this.geometry = new BoxGeometry( 0.3, 1.1, 0.3);
      this.clearMaterial = new MeshBasicMaterial({ color: 0x000000, opacity: 0.0, transparent: true });
      this.clickable = new Mesh(this.geometry, this.clearMaterial)
      this.group.add(this.clickable)

      this.strawGeometry = new CylinderGeometry(.5,.5,10,5,1,0,6.3)
      this.strawMaterial = new MeshBasicMaterial({color: 0xffffff})
      this.strawGeometry.scale(.1, .1, .1)
      this.strawMaterial.side = DoubleSide
      this.lineMaterial = new LineBasicMaterial({color: 0xFF0000, linewidth: 12});
      this.lineMaterial.side = DoubleSide
      this.group.materials.push(this.strawMaterial)
      this.group.materials.push(this.lineMaterial)
      this.straw = new Mesh(this.strawGeometry, this.strawMaterial)
      this.group.add(this.straw)

      const points1 = []
      points1.push(new Vector3(.05, 0, 0));
      points1.push(new Vector3(.05, 0.50, 0));
      points1.push(new Vector3(.05, -0.50, 0));
      this.geometry = new BufferGeometry().setFromPoints(points1);
      this.strawLines = new Line(this.geometry, this.lineMaterial);
      this.lines.add(this.strawLines)

      const points2 = []
      points2.push(new Vector3(-.05, 0, 0));
      points2.push(new Vector3(-.05, 0.50, 0));
      points2.push(new Vector3(-.05, -0.50, 0));
      this.geometry = new BufferGeometry().setFromPoints(points2);
      this.strawLines = new Line(this.geometry, this.lineMaterial);
      this.lines.add(this.strawLines)

      const points3 = []
      points3.push(new Vector3(0, 0, -.05));
      points3.push(new Vector3(0, 0.50, -.05));
      points3.push(new Vector3(0, -0.50, -.05));
      this.geometry = new BufferGeometry().setFromPoints(points3);
      this.strawLines = new Line(this.geometry, this.lineMaterial);
      this.lines.add(this.strawLines)

      const points4 = []
      points4.push(new Vector3(0, 0, .05));
      points4.push(new Vector3(0, 0.50, .05));
      points4.push(new Vector3(0, -0.50, .05));
      this.geometry = new BufferGeometry().setFromPoints(points4);
      this.strawLines = new Line(this.geometry, this.lineMaterial);
      this.lines.add(this.strawLines)

      this.lines.rotation.y = Math.PI/3
      this.group.add(this.lines)
      this.group.scale.set(1.15, 1.15, 1.15)
  }
}
export default Straws;